import { z } from 'zod';
import { idSchema, isoDateTime } from './common.js';
/** Company-level settings stored in the settings table (JSON values). */
export const SETTING_KEYS = [
    'company.name',
    'company.number',
    'company.address',
    'invoice.prefix',
    'invoice.nextNumber',
    'invoice.termsDays',
    'invoice.taxRatePct',
    'invoice.footer',
    'notifications.emailEnabled',
    'notifications.emailFrom',
    'intake.csvMaxRows',
    'intake.requireDuplicateAck',
];
export const settingSchema = z.object({
    key: z.string().min(1).max(120),
    value: z.unknown(),
    updatedBy: idSchema.nullish(),
    updatedAt: isoDateTime,
});
export const settingValueSchema = z.object({
    value: z.unknown(),
    reason: z.string().max(1000).nullish(),
});
/** Health payload — GET /api/health (NOT under /api/v1). */
export const healthSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    service: z.string(),
    version: z.string(),
    uptimeSeconds: z.number(),
    time: isoDateTime,
    db: z.object({ ok: z.boolean(), migrations: z.number().int().optional() }),
});
//# sourceMappingURL=settings.js.map